module.exports = __webpack_public_path__ + "static/media/tiny5.ba024bbf.png";